<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
body{
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  body{ margin: 0 }
  #nav{ display: none }
  @mixin sp {
    @media screen and (max-width: 992px){
      @media screen {
        @content;
      }
    }         
  }
  .only_pc{
    @include sp(){
      display: none;
    }
  }
  .only_sp{
    display: none;
    @include sp(){
      display: block;
    }
  }
  div,a,header{
    box-sizing: border-box;
  }
}

// #nav {
//   padding: 30px;
//   display: none;
//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
<script>
// import dayjs from 'dayjs';
//routerで設定したタイトルとめたタグを反映する
export default {
  methods: {
    createTitleDesc: function(routeInstance) {
      // タイトルを設定
      window.onload = function(){
        if (routeInstance.meta.title) {
          var setTitle = routeInstance.meta.title + " | KURAND(クランド)";
          document.title = setTitle;
        } else {
          document.title = "title is not set";
          location.href = "https://kurand.jp/pages/404";
        }
      }
      // メタタグdescription設定
      if (routeInstance.meta.desc) {
        var setDesc = routeInstance.meta.desc + " | KURAND(クランド)";
        document
          .querySelector("meta[name='description']")
          .setAttribute("content", setDesc);
      } else {
        document
          .querySelector("meta[name='description']")
          .setAttribute("content", "description is not set");
      }

      if (routeInstance.meta.noindex) {
        document
          .querySelector("meta[name='robots']")
          .setAttribute("content", "noindex");
      }
      
      if (routeInstance.meta.ogimage) {
        document
          .querySelector("meta[name='og:image']")
          .setAttribute("content", routeInstance.meta.ogimage);
      }

      if (routeInstance.path.includes('/mume')) {
        window.location = `https://kurand.jp/products/mume`
        document
          .querySelector("link[rel='icon']")
          .setAttribute("href", '/mume_favicon.ico');

        document
          .querySelector("link[rel='apple-touch-icon']")
          .setAttribute("href", '/mume_apple_icon.png');
      }
      if (routeInstance.path.includes('/inuneko-godwork')) {
        window.location = `https://kurand.jp/pages/inuneko-godwork`
      }
      if (routeInstance.path.includes('/shin-e')) {
        window.location = `https://kurand.jp/pages/shin-e`
      }
      if (routeInstance.path.includes('/zetsu')) {
        window.location = `https://kurand.jp/pages/zetsu`
      }
      if (routeInstance.path.includes('/aliens')) {
        window.location = `https://kurand.jp/pages/aliens-galaxy`
      }
      if (routeInstance.path.includes('/kadode-shikou')) {
        window.location = `https://kurand.jp/pages/kadode-shikou`
      }
      if (routeInstance.path.includes('/rikei')) {
        window.location = `https://kurand.jp/pages/rikeikyodai-kiwami`
      }
      if (routeInstance.path.includes('/selection')) {
        window.location = `https://kurand.jp/pages/selection`
      }
      if (routeInstance.path.includes('/hakunacrystal')) {
        window.location = `https://kurand.jp/pages/hakunacrystal`
      }
      if (routeInstance.path.includes('/valentine')) {
        window.location = `https://kurand.jp/pages/valentine`
      }
      if (routeInstance.path.includes('/whiteday')) {
        window.location = `https://kurand.jp/pages/whiteday`
      }
      if (routeInstance.path.includes('/summerchocolate')) {
        window.location = `https://kurand.jp/pages/summer-chocolate`
      }
      if (routeInstance.path.includes('/meisters')){
        window.location = `https://kurand.jp/`
      }
      if (routeInstance.path.includes('/ghostintheshell-sac2045')){
        window.location = `https://kurand.jp/`
      }
      if (routeInstance.path.includes('/kankitsu')){
        window.location = `https://kurand.jp/`
      }
      if (routeInstance.path.includes('/awasu')){
        window.location = `https://kurand.jp/`
      }
      if (routeInstance.path.includes('/umeshu-the-amber')) {
        if (routeInstance.path.includes('/umeshu-the-amber-assemblage')) {
          window.location = `https://kurand.jp/pages/umeshu-the-amber-assemblage`
        }
        else if (routeInstance.path.includes('/umeshu-the-amber-yuzuru')) {
          window.location = `https://kurand.jp/pages/umeshu-the-amber-yuzuru`
        }
        else if (routeInstance.path.includes('/umeshu-the-amber-solera')) {
          window.location = `https://kurand.jp/pages/umeshu-the-amber-solera`
        }
        else {
          window.location = `https://kurand.jp/pages/umeshu-the-amber`
        }
      }
    },
  },
  mounted: function() {
    var routeInstance = this.$route;
    this.createTitleDesc(routeInstance);
  },
  watch: {
    $route(routeInstance) {
      this.createTitleDesc(routeInstance);
    },
  },
};
</script>
